
namespace GeniuzPOS.Product {

    @Serenity.Decorators.registerClass()
    export class CsConceptDialog extends Serenity.EntityDialog<CsConceptRow, any> {
        protected getFormKey() { return CsConceptForm.formKey; }
        protected getIdProperty() { return CsConceptRow.idProperty; }
        protected getLocalTextPrefix() { return CsConceptRow.localTextPrefix; }
        protected getNameProperty() { return CsConceptRow.nameProperty; }
        protected getService() { return CsConceptService.baseUrl; }
        protected getDeletePermission() { return CsConceptRow.deletePermission; }
        protected getInsertPermission() { return CsConceptRow.insertPermission; }
        protected getUpdatePermission() { return CsConceptRow.updatePermission; }

        protected form = new CsConceptForm(this.idPrefix);

    }
}